import { ComboboxItem } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { clinicQKeys } from "./queryKeys";


const queryFn = () => {
  return api.get("clinic/rad-services");
};

const select = (res: any) => {
  //   console.log(res.data);

  if (res.data.length) {
    const newData: ComboboxItem[] = [];

    for (const i in res.data.reverse()) {
      const { type, _id } = res.data[i];

      newData.push({ label: type as string, value: type });
    }
    // console.log(newData);
    return newData;
  }
  return null;
};

export const useGetClinicRadiologies = () => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: clinicQKeys.radiologies(),
    queryFn,
    select,
    staleTime: Infinity, // Relatively long stale time because it does not change often

    onError: (res: any) => {
      console.error("[From Get Clinic Radiologies]", res);
      handleErrors(res, "query");
    },
  });
};
